export default {
  ORG_GOALS_ROUTE: '/dashboard/goals'
};
